// extracted by mini-css-extract-plugin
export default {"group":"R46h0ZNHHa7acm3UDuI6","labelText":"sliKzTYHpzZBJFv3pr9M","time":"JNxRL1YiAdsmU2JFpzrr","finished":"n0PeYAWHEKwVIjSTZ7zs","arrow":"NwWZaqe5BbqRWfXK0UdM"};